import { Box, Flex } from '@radix-ui/themes'
import Skeleton from 'react-loading-skeleton'
import styles from './bulls-eye-game-skeleton.module.scss'

export const BullsEyeGamePoolSkeleton: React.FC = () => {
  return (
    <>
      <Box className={styles.panel}>
        <Flex
          align={'center'}
          gap={'3'}
        >
          <Skeleton
            circle
            width={'7rem'}
            height={'7rem'}
          />

          <Flex
            direction={'column'}
            gap={'1'}
            flexGrow={'1'}
          >
            <Skeleton
              height={'3.5rem'}
              width={'60%'}
            />

            <Skeleton
              height={'2rem'}
              width={'80%'}
            />
          </Flex>
        </Flex>
      </Box>

      <Box className={styles.panel}>
        <Skeleton
          height={'3rem'}
          width={'40%'}
        />

        <Flex
          direction={'column'}
          gap={'2'}
          mt={'3'}
        >
          <Skeleton
            count={5}
            height={'6.5rem'}
            borderRadius={'1.5rem'}
          />
        </Flex>
      </Box>

      <Box className={styles.panel}>
        <Skeleton
          height={'3rem'}
          width={'50%'}
        />

        <Flex
          direction={'column'}
          gap={'2'}
          mt={'3'}
        >
          <Skeleton
            height={'6.5rem'}
            borderRadius={'1.5rem'}
          />

          <Skeleton
            height={'7rem'}
            borderRadius={'999px'}
          />
        </Flex>
      </Box>
    </>
  )
}
